import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface RememberState {
  isRemember: boolean;
  email: any;
  password: any;
  setIsRemember: (isRemember: boolean) => void;
  setInfoRemember: (info: any) => void;
  clearRemember: () => void;
}

export const useRememberStore = create<RememberState>()(
  persist(
    (set) => ({
      isRemember: false,
      email: undefined,
      password: undefined,
      setIsRemember: (isRemember: boolean) => {
        set({ isRemember });
      },
      setInfoRemember: (info: any) =>
        set({ email: info?.email, password: info?.password }),
      clearRemember: () => {
        set({ isRemember: false, email: undefined, password: undefined });
      },
    }),
    {
      name: "auth-token-sungga-manager-remember",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
